import n from "./ghl-ui.es1157.js";
const y = (o) => {
  const {
    textColorBase: t,
    opacity1: c,
    opacity2: p,
    opacity3: i,
    opacity4: a,
    opacity5: e
  } = o;
  return {
    color: t,
    opacity1Depth: c,
    opacity2Depth: p,
    opacity3Depth: i,
    opacity4Depth: a,
    opacity5Depth: e
  };
}, h = {
  name: "Icon",
  common: n,
  self: y
}, r = h;
export {
  r as default,
  y as self
};
